// src/services/APIs/NotificationService.ts
import {
  Notification,
  NotificationList,
  NotificationPayload,
} from "@/utils/types/notification";
import { get, post, patch, del } from "@/services/axiosUitils";

const basePath = "/notification-using-celery/notifications_using_celery/";

class NotificationService {
  getTenantEmailConfigs = async (): Promise<any[]> => {
    return await get("/dropdown/tenant-email-config/");
  };
  getAllNotifications = async (params?: {
    page?: number;
    pageSize?: number;
  }): Promise<NotificationList> => {
    return await get(basePath, { params });
  };

  getTenantRoles = async (): Promise<any[]> => {
    return await get("/dropdown/TenantRole/");
  };

  getNotificationById = async (id: string): Promise<Notification> => {
    return await get(`${basePath}${id}/`);
  };

  getReferenceEmail = async (schemaName: string): Promise<any> => {
    const data = await get(`dropdown/schema/all-column-dropdown/`, {
      params: { schema_name: schemaName },
    });

    if (data && Array.isArray(data.fields)) {
      return data.fields.map((f: any) => ({
        label: f.title ?? f.field_name,
        value: f.field_name,
        type: f.field_type,
      }));
    }
    return [];
  };
  getPrintFormats = async (schemaId: string): Promise<any[]> => {
    if (!schemaId) {
      return [];
    }
    const data = await get(`/dropdown/printformat/`, {
      params: { schema_id: schemaId },
    });
    // The API returns the data directly, not inside a 'fields' property.
    if (data && Array.isArray(data)) {
      return data.map((f: any) => ({
        label: f.label,
        value: f.value,
      }));
    }
    return [];
  };
  createNotification = async (
    payload: NotificationPayload
  ): Promise<Notification> => {
    return await post(basePath, payload);
  };

  updateNotification = async (
    id: string,
    payload: NotificationPayload
  ): Promise<Notification> => {
    return await patch(`${basePath}${id}/`, payload);
  };

  deleteNotification = async (id: string): Promise<void> => {
    return await del(`${basePath}${id}/`);
  };
}

const instance = new NotificationService();
export default instance;
